import { createEntityComboBox } from './helpers/createEntityComboBox';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';

export type SelectableOutboundTollingAgreement = QueryHookResult<
  typeof useOutboundTollingAgreementsQuery
>[number];

export const useOutboundTollingAgreementsQuery = createQueryHook(
  'shared.selectOutboundTollingAgreement',
  (params: {
    searchTerm?: string;
    ids?: string[];
    isActive?: boolean;
    processorAccountId?: string;
  }) => ({
    outboundTollingAgreements: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
          isActive: params.isActive ?? true,
          processorAccountId: params.processorAccountId,
        },
        pagination: {
          offset: 0,
          limit: 20,
        },
      },
      entries: {
        id: true,
        agreementNumber: true,
        processorAccount: {
          id: true,
          name: true,
        },
        processingType: {
          id: true,
          name: true,
        },
        isActive: true,
      },
    },
  }),
  {
    select: (data) => data.outboundTollingAgreements.entries ?? [],
  },
);

export const SelectOutboundTollingAgreement =
  createEntityComboBox.remotelySearched(
    'SelectOutboundTollingAgreement',
    useOutboundTollingAgreementsQuery,
    {
      formatLabel: (entity) =>
        `${entity.agreementNumber} - ${entity.processorAccount?.name ?? 'Unknown'}`,
      formatSubLabel: (entity) => entity.processingType?.name ?? '',
    },
  );
